(function () {
  /* ULTRACOAT UK — Find Your Coating (Round 14, 2026-08-21)
     4 audiences x 6 priorities = 24 routes, each returning exactly ONE product.
     Product names, descriptions and URLs come from the JSON block rendered by
     sections/uc-finder.liquid, which resolves them from Shopify at render time.
     No URL is constructed here; if a product has no URL the card shows a
     non-link COMING SOON state instead of a dead link.
     Amendment 2026-08-21: the "trim" priority means exterior plastic trim,
     including unpainted exterior plastics — not interior dashboard care. */
  var MATRIX = {
    "first_time.easy":       "aurora",
    "first_time.gloss":      "carbon",
    "first_time.durability": "skyline",
    "first_time.trim":       "aurora",
    "first_time.glass":      "vista",
    "first_time.wheels":     "aurora",

    "enthusiast.easy":       "aurora",
    "enthusiast.gloss":      "skyline",
    "enthusiast.durability": "magnite",
    "enthusiast.trim":       "one",
    "enthusiast.glass":      "one",
    "enthusiast.wheels":     "one",

    "experienced.easy":       "one",
    "experienced.gloss":      "magnite",
    "experienced.durability": "set",
    "experienced.trim":       "gravity",
    "experienced.glass":      "vista",
    "experienced.wheels":     "gravity",

    "pro.easy":       "magnite",
    "pro.gloss":      "set",
    "pro.durability": "premium",
    "pro.trim":       "gravity",
    "pro.glass":      "vista",
    "pro.wheels":     "gravity"
  };

  function init (root) {
    var scope = root || document;
    var section = scope.querySelector(".uc-finder");
    if (!section || section.dataset.ucFinderReady === "1") return;

    var form   = section.querySelector(".uc-finder__form");
    var result = section.querySelector(".uc-finder__result");
    var data   = section.querySelector("#uc-finder-products");
    if (!form || !result || !data) return;

    var PRODUCTS;
    try { PRODUCTS = JSON.parse(data.textContent); } catch (e) { return; }

    var nameEl  = result.querySelector("[data-name]");
    var claimEl = result.querySelector("[data-claim]");
    var proEl   = result.querySelector("[data-pro]");
    var ctaEl   = result.querySelector("[data-cta]");
    var soonEl  = result.querySelector("[data-soon]");
    /* R27: progress readout. Purely derived from the same two radios the matrix
       already reads, so it cannot drift from the recommendation. */
    var countEl = result.querySelector("[data-progress-count]");
    var msgEl   = result.querySelector("[data-progress-msg]");

    function update () {
      var aud = form.querySelector('input[name="audience"]:checked');
      var pri = form.querySelector('input[name="priority"]:checked');
      if (!aud || !pri) {
        var answered = (aud ? 1 : 0) + (pri ? 1 : 0);
        if (countEl) { countEl.textContent = answered + " OF 2 ANSWERED"; }
        if (msgEl) {
          msgEl.textContent = answered === 0
            ? "Select one option in each step to reveal your recommendation."
            : "Choose one more option.";
        }
        result.setAttribute("data-state", "empty");
        return;
      }
      var key = MATRIX[aud.value + "." + pri.value];
      var p = key ? PRODUCTS[key] : null;
      if (!p) {
        result.setAttribute("data-state", "empty");
        return;
      }

      nameEl.textContent  = p.name;
      claimEl.textContent = p.desc;

      if (p.pro) { proEl.hidden = false; } else { proEl.hidden = true; }

      if (p.url) {
        ctaEl.href = p.url;
        ctaEl.textContent = "VIEW " + p.name.toUpperCase() + " →";
        ctaEl.hidden = false;
        soonEl.hidden = true;
      } else {
        ctaEl.removeAttribute("href");
        ctaEl.hidden = true;
        soonEl.textContent = "COMING SOON";
        soonEl.hidden = false;
      }

      result.setAttribute("data-state", "live");
    }

    /* One listener, on the section's own container — never on document/window,
       so nothing can accumulate across theme-editor section reloads. */
    form.addEventListener("change", update);
    section.dataset.ucFinderReady = "1";
    section.ucFinderSync = update;
    update();
  }

  function boot () { init(document); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  /* Shopify theme editor: re-initialise only the reloaded section. The guard
     flag lives on the new DOM node, so the old node and its listener are
     discarded with it — no duplicate listeners, no accumulation. */
  document.addEventListener("shopify:section:load", function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector(".uc-finder")) init(e.target);
  });

  /* Change 3 — Back/Forward consistency. A history restore can reinstate the
     radios without firing a change event, so the result card, which is derived
     state, keeps whatever it rendered at parse time: the initial prompt. Re-run
     the SAME update() — it already reads both checked radios directly and never
     touches event.target, so the radios remain the single source of truth and
     there is no second matrix or parallel renderer. requestAnimationFrame defers
     the read until after the browser has restored form state. Deliberately not
     gated on event.persisted: the non-bfcache restore is the failing path, and
     on the bfcache path this is a no-op because the DOM already matches. */
  window.addEventListener("pageshow", function () {
    requestAnimationFrame(function () {
      var section = document.querySelector(".uc-finder");
      if (!section) return;
      if (typeof section.ucFinderSync === "function") { section.ucFinderSync(); }
      else { init(document); }
    });
  });
})();
